<template>
  <div class="my-visitor">
    <div class="visitor-top">
      <div class="top-div">
        <div class="div-bg" v-for="(item,index) in toList" :key="index">
          <div class="div-img">
            <img :src="item.img" alt />
          </div>
          <div>
            <div class="v-num">{{item.value1}}人</div>
            <div class="v-label">{{item.label}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="v-data">
      <ul>
        <li
          :class="checkLi==index?'li-sty li-check-sty':'li-sty'"
          v-for="(item,index) in liList"
          :key="index"
          @click="changLi(item,index)"
        >{{item}}</li>
      </ul>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div
            class="v-info-box"
            v-for="(item,index) in dataList"
            :key="index"
            @click="toDetail(item)"
          >
            <div class="v-title-time">{{item.createTime}}</div>
            <div class="info-div">
              <div class="v-img">
                <img :src="item.headImg" alt />
              </div>
              <div class="v-div">
                <div class="v-info-div">
                  <div class="v-name">{{item.username}}</div>
                  <div class="v-phone">{{item.phoneNo}}</div>
                </div>
                <div class="v-time">{{item.digest}}</div>
              </div>
              <div class="v-right">></div>
              <img class="status-img" :src="checkLi=='0' ? liImg0 : liImg1" alt />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
export default {
  data() {
    return {
      todayVisitorCount:'',
      totalVisitorCount:'',
      toList: [
        {
          img: require('./img/visitor0.png'),
          label: '今日访客',
          value: '30'
        },
        {
          img: require('./img/visitor.png'),
          label: '总访问量',
          value: '10030'
        },
      ],
      dataList: [],
      liList: ['未读', '已读'],
      checkLi: 0,//绑定未读
      liImg0: require('@/assets/publicImg/status0.png'),
      liImg1: require('@/assets/publicImg/status1.png'),
      headerImg: require(`../../assets/img/user.png`),
      page: 1,
      size: 10,
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  methods: {
    onLoad() {
      if (this.checkLi == '0') {
        this.getunread()//未读数据
      } else if (this.checkLi == '1') {
        this.getread()//已读数据
      }
    },
    getunread() {//未读数据
      this.getData()
    },
    getread() {//已读数据
      this.getData()
    },
    onRefresh() {
      // 清空列表数据
      this.page = 1
      this.dataList = []
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    getData() {
      let that = this
      let data = {
        cusType: 'all',
        agentUserId: localStorage.getItem('userid'),
        searchStr: that.value,
        page: that.page,
        size: that.size
      }
      that.$fetchPost(URLTB.getClients.url, data).then(res => {
        that.refreshing = false
        that.loading = false
        that.toList[0].value1=res.data.data.todayVisitorCount
        that.toList[1].value1=res.data.data.totalVisitorCount
        console.log(that.toList);
        let list = res.data.data.list.records
        list.map(x => {
          that.$set(x, 'newStatus', false)
          if (x.attention == '1') {
            that.$set(x, 'newStatus', true)
          }
        })
        that.total = res.data.data.list.total
        if (list == null || list.length <= 0) {
          //加载完成
          that.finished = true
          return
        }
        if (that.page > 1) {
          that.dataList = [...that.dataList, ...list]
        } else {
          that.dataList = list
        }
        if (that.page * that.size >= that.total) {
          that.finished = true
          return
        }

        if (that.page * that.size < that.total) {
          that.page++
        }

      })
    },
    changLi(item, index) {//改变是否已读状态
      this.checkLi = index
      if (this.checkLi == '0') {//未读
        this.page = 1
        this.dataList = []
        this.loading = true
        this.finished = false
        this.getunread()
      } else {
        this.page = 1
        this.dataList = []
        this.loading = true
        this.finished = false
        this.getread()
      }
      this.getData()
    },
    toDetail(item){
      this.$router.push({path:'/clientMaterial',query: { userId: item.userId }})
    }
  }
}
</script>

<style lang="less" scoped>
.my-visitor {
  height: 100vh;
  background: #fff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  img {
    width: 100%;
    height: 100%;
  }
  .visitor-top {
    width: 375px;
    height: 125px;
    background: url("./img/v-bg.png") no-repeat 100%;
    background-size: 100% 100%;
    overflow: hidden;
    .top-div {
      width: 355px;
      margin: 14px auto auto;
      display: flex;
      justify-content: space-between;
      .div-bg {
        width: 168px;
        height: 90px;
        background: url("./img/v-bg1.png") no-repeat 100%;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        color: #333333;
        .div-img {
          width: 39px;
          height: 36px;
          margin: 0 14px 0 20px;
        }
        .v-num {
          font-family: DIN Alternate;
          font-weight: bold;
          font-size: 18px;
        }
        .v-label {
          font-weight: 400;
          font-size: 12px;
        }
      }
    }
  }
  .v-data {
    width: 355px;
    margin: 15px auto auto;
    font-weight: 400;
    font-size: 11px;
    color: #666666;
    ul {
      display: flex;
      .li-sty {
        width: 45px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 11px;
        font-weight: 400;
        color: #999999;
        background: url("../../assets/publicImg/li-bg6.png") no-repeat 100%;
        background-size: 100% 100%;
        &:last-child {
          margin-left: 5px;
        }
      }
      .li-check-sty {
        font-weight: 500;
        color: #ffffff;
        background: url("../../assets/publicImg/li-bg2.png") no-repeat 100%;
        background-size: 100% 100%;
      }
    }
    .v-info-box {
      padding: 0 10px;
      margin-top: 7px;
      background: url("../../assets/publicImg/con-bg.png") no-repeat 100%;
      background-size: 100% 100%;
      border: 1px solid transparent;
      position: relative;
      .v-title-time {
        margin: 10px 0;
      }
      .info-div {
        height: 40px;
        display: flex;
        .v-img {
          width: 40px;
          height: 40px;
        }
        .v-div {
          margin-left: 25px;
          .v-info-div {
            display: flex;
            .v-name {
              margin-bottom: 5px;
              font-weight: 500;
              font-size: 12px;
              color: #333333;
            }
            .v-phone {
              padding-left: 40px;
            }
          }
          .v-time {
          }
        }
        .v-right {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          color: #d4d4d4;
        }
        .status-img {
          width: 13px;
          height: 13px;
          position: absolute;
          top: 15px;
          right: 15px;
        }
      }
    }
  }
}
</style>